import type { UseCaseContent } from "@/lib/use-cases/content";

export const HI_USE_CASES: Partial<Record<string, UseCaseContent>> = {
  clippers: {
    related: [
      "/features/auto-clip",
      "/features/video-cutter",
      "/calculators/clips-from-one-video",
      "/calculators/views-to-money",
    ],
    navTitle: "Clippers",
    seoTitle: "Videos clip करके पैसे कमाएं: Clipping Campaigns",
    seoDescription:
      "Clipping campaigns ढूंढें, AI से viral clips काटें और अपने views track करें, सब Crayo के अंदर। Clipping शुरू करके पैसे कमाने का सबसे तेज़ तरीका।",
    heroPrefix: "जिन creators को आप पहले से देखते हैं, उनके",
    heroHighlight: "videos clip करके",
    heroSuffix: "पैसे कमाएं",
    description:
      "Crayo की Content Library में live clipping campaigns browse करें, AI से minutes में clips काटें और हर view track करें। काम ढूंढें और काम करें, एक ही app में।",
    buttonText: "Campaigns देखें",
    buttonLink: "https://crayo.ai/content-library",
    steps: [
      {
        title: "Campaign ढूंढें",
        description:
          "Content Library खोलें और active clip-reward campaigns browse करें, जिनमें source footage तैयार मिलता है।",
      },
      {
        title: "Minutes में clip करें",
        description:
          "Auto Clip सबसे दमदार moments ढूंढता है, या Clip It से ठीक वही काटें जो आप चाहते हैं, subtitles automatically लग जाते हैं।",
      },
      {
        title: "Post करें और track करें",
        description:
          "अपने accounts पर publish करें और View Tracker से views follow करें, ताकि आपको हमेशा पता रहे क्या चल रहा है।",
      },
    ],
    benefits: [
      {
        title: "Campaigns खुद आप तक आती हैं",
        description:
          "न cold DMs, न Discord पर ढूंढते फिरना। Active campaigns footage के साथ Crayo के अंदर ही रहती हैं।",
      },
      {
        title: "Viral moments, आपके लिए ढूंढे हुए",
        description:
          "Auto Clip लंबे videos scan करके post करने लायक moments सामने लाता है, ताकि आपको घंटे भर के VODs scrub न करने पड़ें।",
      },
      {
        title: "Captions सेकंडों में",
        description:
          "हर clip को automatically साफ़, styled subtitles मिलते हैं, यही फर्क है देखे जाने वाले clip और scroll कर दिए जाने वाले clip में।",
      },
      {
        title: "अपने numbers जानें",
        description:
          "View Tracker आपके सभी accounts की posts follow करता है, तो performance track करना spreadsheet का काम नहीं रहता।",
      },
      {
        title: "Editing का कोई background ज़रूरी नहीं",
        description: "अगर आप अच्छा moment चुन सकते हैं, तो बाकी Crayo संभाल लेता है।",
      },
      {
        title: "सब कुछ एक tab में",
        description:
          "Campaigns, clipping, captions और tracking एक ही app में रहते हैं, काम ढूंढने से deliver करने तक tools बदलने की ज़रूरत नहीं।",
      },
    ],
    relatedFeatures: ["auto-clip", "video-cutter", "video-crop", "youtube-downloader"],
    faqs: [
      {
        question: "मुझे clipping campaigns कहाँ मिलेंगी?",
        answer:
          "ये Crayo की Content Library में built-in हैं। उसे खोलें, जो live है वो browse करें और clipping शुरू करें। Source videos campaign की तरफ से मिलते हैं।",
      },
      {
        question: "Payout कैसे काम करता है?",
        answer:
          "हर campaign अपने terms और rewards खुद तय करती है, जो clipping शुरू करने से पहले ही दिखते हैं। Campaign की details पढ़ें, clip करें, post करें और उसके terms के हिसाब से reward पाएं।",
      },
      {
        question: "क्या मुझे editing का experience चाहिए?",
        answer:
          "नहीं। Auto Clip moments ढूंढता है, subtitles automatic हैं और editor trims और crops संभालता है। Technical skill से ज़्यादा taste मायने रखता है।",
      },
      {
        question: "क्या मैं ऐसे creators के clips बना सकता हूँ जिनकी कोई campaign नहीं चल रही?",
        answer:
          "हाँ। कोई भी YouTube link paste करें या footage upload करें और उसी तरह clip करें। Campaigns बस पैसे कमाने का सबसे तेज़ रास्ता हैं।",
      },
    ],
  },
  "podcast-clipping": {
    related: [
      "/compare/crayo-vs-descript",
      "/compare/crayo-vs-riverside-magic-clips",
      "/features/auto-clip",
      "/features/speech-enhancer",
      "/use-cases/agencies",
      "/calculators/clips-from-one-video",
    ],
    navTitle: "Podcast Clips",
    seoTitle: "Podcast Clip Generator: episodes से shorts बनाएं",
    seoDescription:
      "एक podcast episode से हफ्ते भर के clips। AI best moments ढूंढता है, audio साफ़ करता है, captions जोड़कर TikTok, Reels, Shorts के लिए crop करता है।",
    heroPrefix: "एक episode से",
    heroHighlight: "पूरे हफ्ते के",
    heroSuffix: "clips बनाएं",
    description:
      "Episode डालें, या बस एक YouTube link, और AI को post करने लायक moments ढूंढने दें। Captions, vertical crop और साफ़ audio शामिल।",
    buttonText: "Episode free में clip करें",
    buttonLink: "https://crayo.ai/create/auto-clip",
    steps: [
      {
        title: "अपना episode जोड़ें",
        description:
          "File upload करें या built-in downloader से YouTube link paste करें। पूरे episodes का स्वागत है।",
      },
      {
        title: "AI को moments ढूंढने दें",
        description:
          "Auto Clip पूरी बातचीत scan करता है और वे हिस्से निकालता है जो scroll करने वाले को सबसे ज़्यादा hook करें।",
      },
      {
        title: "Polish करें और post करें",
        description:
          "Speech enhancer audio साफ़ करता है, captions automatically लगते हैं, और हर clip TikTok, Reels और Shorts के लिए 9:16 में crop होता है।",
      },
    ],
    benefits: [
      {
        title: "Timelines scrub करना बंद करें",
        description:
          "घंटे भर की बातचीत, minutes में scan। आप clips review करते हैं, raw footage नहीं।",
      },
      {
        title: "Podcast audio, ठीक किया हुआ",
        description:
          "Speech enhancer कमरे की echo और ऊपर-नीचे levels साफ़ करता है ताकि clips studio version जैसे सुनाई दें।",
      },
      {
        title: "Captions जो clip को संभालते हैं",
        description:
          "ज़्यादातर short-form viewers mute करके देखते हैं। हर clip styled, accurate subtitles के साथ निकलता है।",
      },
      {
        title: "Vertical, बिना अजीब crop के",
        description:
          "Horizontal episodes को साफ़-सुथरे तरीके से 9:16 में reframe करें, बजाय ऐसा letterboxed video post करने के जिसे कोई नहीं देखता।",
      },
      {
        title: "बस एक link से काम",
        description:
          "अपने podcast host से export करने की ज़रूरत नहीं। YouTube URL paste करें और clipping शुरू करें।",
      },
      {
        title: "सिर्फ podcasts नहीं",
        description:
          "Webinars, coaching calls, course lessons, interviews: अगर लंबी बातचीत है, तो Crayo उसे clip करता है।",
      },
    ],
    relatedFeatures: ["auto-clip", "speech-enhancer", "youtube-downloader", "video-crop"],
    faqs: [
      {
        question: "Crayo को कैसे पता चलता है कौन से moments clip करने हैं?",
        answer:
          "Auto Clip पूरा episode analyze करता है और सबसे strong hooks वाले हिस्से सामने लाता है, जैसे stories, hot takes और punchlines, फिर आप चुनते हैं कौन से post करने हैं।",
      },
      {
        question: "मैं coach या course creator हूँ, podcaster नहीं। क्या यह मेरे content पर काम करेगा?",
        answer:
          "हाँ। कोई भी लंबा, बातचीत वाला content, webinars और workshops से लेकर course modules और client calls तक, बिल्कुल उसी तरह clip होता है।",
      },
      {
        question: "क्या मैं सीधे YouTube से clip कर सकता हूँ?",
        answer:
          "हाँ। Link paste करें, Crayo built-in downloader से video खींच लेता है, और minutes में आप clipping कर रहे होते हैं। सिर्फ वही content clip करें जिसके rights आपके पास हों।",
      },
      {
        question: "Finished clips कैसे दिखते हैं?",
        answer:
          "Vertical 9:16 video, जिसमें styled subtitles burn किए हुए और साफ़ audio, TikTok, Reels और Shorts पर जस का तस post करने के लिए तैयार।",
      },
    ],
  },
  streamers: {
    related: [
      "/features/auto-clip",
      "/features/video-crop",
      "/use-cases/clippers",
      "/calculators/clips-from-one-video",
      "/compare/crayo-vs-eklipse",
      "/compare/crayo-vs-streamladder",
    ],
    navTitle: "Streamers",
    seoTitle: "Streamers के लिए Twitch और Kick Clip Maker",
    seoDescription:
      "Stream VODs को channel बढ़ाने वाले shorts में बदलें। AI hype moments ढूंढता है, captions जोड़ता है और TikTok, Reels, Shorts के लिए clips format करता है।",
    heroPrefix: "अपने",
    heroHighlight: "stream VODs",
    heroSuffix: "को channel बढ़ाने वाले shorts में बदलें",
    description:
      "Crayo Twitch और Kick VODs के सबसे high-energy moments ढूंढकर उन्हें TikTok, Reels और Shorts के लिए format करता है और छोटे vertical clips बनाता है। यह उन streamers के लिए है जो पहले से record की गई footage से clips चाहते हैं।",
    buttonText: "अपना VOD free में clip करें",
    buttonLink: "https://crayo.ai/create/auto-clip",
    steps: [
      {
        title: "VOD लाएं",
        description:
          "अपना Twitch या Kick VOD upload करें, या built-in downloader से YouTube पर पड़ा stream export उठाएं।",
      },
      {
        title: "AI hype ढूंढता है",
        description:
          "Auto Clip घंटों का stream scan करके clutch plays, rage moments और chat उड़ा देने वाले हिस्से निकालता है।",
      },
      {
        title: "Vertical में format करें और post करें",
        description:
          "Streamer layout जिसमें आपका facecam सबसे आगे, auto captions, 9:16 crop, export।",
      },
    ],
    benefits: [
      {
        title: "आपके VODs content की खान हैं",
        description:
          "हर stream में आपके best short-form clips पहले से मौजूद हैं। Crayo उन्हें बाहर निकालता है ताकि वे आपके archive में दबे न रह जाएं।",
      },
      {
        title: "सोने के बाद clip करें, सोने की जगह नहीं",
        description:
          "छह घंटे stream करके तीन घंटे edit करना ही streamers को burn out करता है। Scrubbing का काम Auto Clip करता है।",
      },
      {
        title: "Facecam-first layouts",
        description:
          "खास streamers के लिए बनी formatting: आपका cam और gameplay, vertical screen के लिए सजाए हुए।",
      },
      {
        title: "Audio का chaos साफ़ करें",
        description:
          "Speech enhancer game audio की घुसपैठ और mic की ऊपर-नीचे quality संभालता है ताकि आपकी commentary सही में सुनाई दे।",
      },
      {
        title: "Shorts आपका discovery engine हैं",
        description:
          "TikTok और Shorts उन लोगों तक पहुंचते हैं जो कभी Twitch directory scroll नहीं करेंगे। लगातार clips post करना ही वो तरीका है जिससे छोटे streamers लोगों तक पहुंचते हैं।",
      },
      {
        title: "जब तक moment गरम है, post करें",
        description:
          "आज रात के stream को minutes में clip करें, ताकि short तब आए जब chat अभी भी उसी की बात कर रहा हो।",
      },
    ],
    relatedFeatures: ["auto-clip", "speech-enhancer", "video-crop", "video-cutter"],
    faqs: [
      {
        question: "क्या यह Twitch और Kick दोनों पर काम करता है?",
        answer:
          "हाँ। किसी भी platform से अपना VOD लाएं (या YouTube पर रखा stream archive) और उसी तरह clip करें।",
      },
      {
        question: "मेरे streams 4+ घंटे के होते हैं। क्या यह संभाल लेगा?",
        answer:
          "यही तो मकसद है। Auto Clip लंबी footage के लिए ही बना है। यह पूरा VOD scan करके आपको moments थमा देता है, तो लंबाई फायदा है, बोझ नहीं।",
      },
      {
        question: "क्या clips से stream सच में बढ़ता है?",
        answer:
          "Short-form वही जगह है जहाँ नए viewers उन streamers को खोजते हैं जो अभी बड़े नहीं हैं। Clips अच्छे streams की जगह नहीं लेंगे, लेकिन छोटे streamer के पास यही सबसे भरोसेमंद top-of-funnel है।",
      },
      {
        question: "क्या हर clip में मेरा facecam चाहिए?",
        answer:
          "नहीं। Streamer layout optional है, तो हर clip के लिए full-screen gameplay, facecam-first या split layout चुनें।",
      },
    ],
  },
};
